import { useHMSRoleChangeNotification } from "../hms";
import { useLivekitRoleChangeNotification } from "../livekit";
import type { ProviderRoleChangeNotification } from "../types";
import { useProviderHook } from "./useProviderHook";

export const useProviderRoleChangeNotification =
  (): ProviderRoleChangeNotification =>
    useProviderHook({
      hms: useHMSRoleChangeNotification,
      livekit: useLivekitRoleChangeNotification,
    })();
